import styled from 'styled-components';
import { ArrowDirection, rotationMap } from './index';

export const ArrowStyled = styled.svg<{
  $direction: ArrowDirection;
}>`
  cursor: pointer;
  transition: transform 0.2s ease;

  ${({ $direction }) => ({ transform: rotationMap[$direction] })};
`;
